export const SET_USER = 'SET_USER'
export const LOGOUT = 'LOGOUT'



// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js